// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"474":"Overview","950":"MicrogridOverview"}[chunkId] || chunkId) + "." + {"310":"600a5bdc","474":"1c250b2b","950":"553bedb7"}[chunkId] + ".chunk.css";
};